import type { ElementType } from 'react';
import type { Nullable } from 'corgi-types';

import { Element } from 'common/types/tracking';
import { SideNavPlacement, trackNavigationClick } from '../tracking';
import type { NavigationListItemProps } from '../types';

export const NAV_BUTTON_TEST_ID = 'navigation-button';
export const NAV_LINK_TEST_ID = 'navigation-link';

interface UseNavigationItemOptions extends NavigationListItemProps {
  selectedItem: Nullable<number>;
}

export const useNavigationItemProps = ({
  id,
  item,
  groupId,
  listLength,
  navLevel,
  onNavigationClick,
  activeItem,
  selectedItem,
  shopName,
  navItemParent,
  tabName,
}: UseNavigationItemOptions) => {
  const trackingOptions = {
    label: item.name,
    position: id,
    length: listLength,
    placement:
      item.isPrimary || typeof item.isPrimary !== 'boolean'
        ? SideNavPlacement.Primary
        : SideNavPlacement.Secondary,
    navLevel: selectedItem !== null && typeof navLevel === 'number' ? navLevel + 1 : navLevel,
    shopName,
    navItemParent,
    tabName,
  };

  return {
    navigationButtonProps: {
      'data-item-id': id,
      'data-group-id': groupId,
      'data-testid': NAV_BUTTON_TEST_ID,
      onClick: (event: React.MouseEvent) => {
        onNavigationClick(event);
        trackNavigationClick({ ...trackingOptions, element: Element.Button });
      },
      isActive: activeItem === id,
      as: 'button' as ElementType,
      modifiers: item.modifiers,
    },
    navigationLinkProps: {
      'data-testid': NAV_LINK_TEST_ID,
      href: item.href,
      modifiers: item.modifiers,
      onClick: () => {
        trackNavigationClick({ ...trackingOptions, element: Element.Link });
      },
    },
  };
};
